import { render, staticRenderFns } from "./MarkSupplyProductArrival.vue?vue&type=template&id=245f1b28&"
import script from "./MarkSupplyProductArrival.vue?vue&type=script&lang=js&"
export * from "./MarkSupplyProductArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports